import Spin from "antd/lib/spin";
import React from "react";
import ZSpinProps from "./interface";
import ZContentLoadingIcon from "@atoms/ZContentLoadingIcon";

const ZSpin: React.FC<ZSpinProps> = props => {
	return (
		<Spin
			indicator={
				<ZContentLoadingIcon loading_icon={props.loading_icon} />
			}
			{...props}
		/>
	);
};

export default ZSpin;
